
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34636',
  depVersions: {
  "documents-public-ui": "static-1.34636",
  "atom": "static-1.5120",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2544",
  "client-types": "static-1.473",
  "cssUtils": "static-1.801",
  "customer-data-filters-ui": "static-1.39963",
  "customer-data-objects": "static-1.7721",
  "customer-data-property-utils": "static-1.8136",
  "documents-lib": "static-1.34641",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85980",
  "FormUrlGenerator": "static-2.4765",
  "foundations-theming-specialty": "static-1.2179",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5635",
  "hs-test-utils": "static-1.8061",
  "hub-http": "static-1.6268",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11826",
  "HubStyleTokens": "static-2.11519",
  "I18n": "static-7.1633",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3066",
  "jasmine-runner": "static-1.6509",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7201",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5443",
  "quartz": "static-1.7087",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5380",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8217",
  "reference-resolvers-lite": "static-1.8141",
  "reporting-data": "static-1.67756",
  "reporting-reports": "static-1.67434",
  "reporting-snowflake": "static-1.56374",
  "reporting-testing-lib": "static-1.9689",
  "reporting-visualizations": "static-1.59832",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8989",
  "sanitize": "static-1.4521",
  "sanitize-text": "static-1.8187",
  "self-service-api": "static-1.10292",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1793",
  "signup-constants": "static-1.18935",
  "signup-ui-url-generator": "static-2.8099",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4805",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4808",
  "ui-addon-form-validation": "static-1.11035",
  "ui-asset-management-lib": "static-1.11097",
  "ui-images": "static-2.1163",
  "UIComponents": "static-3.8465",
  "usage-tracker": "static-1.7395",
  "usage-tracker-container": "static-1.7385",
  "usage-tracker-core": "static-1.7245",
  "viral-links-lib": "static-1.7113",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9710",
  "foundations-components": "static-1.8020",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.865",
  "quartz-core": "static-1.6306",
  "quick-fetch": "static-1.3953",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4697",
  "ui-addon-i18n": "static-1.11196",
  "ui-addon-upgrades": "static-9.18061",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3435",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3364",
  "quartz-webpack": "static-1.3311",
  "foundations-assets": "static-1.4915",
  "foundations-theming": "static-1.4463",
  "hub-http-shared-msw-handlers": "static-1.10073",
  "hubspotter-http": "static-1.4687",
  "sassPrefix": "static-1.157",
  "events-data-lib": "static-1.272",
  "conversations-skeleton-state": "static-1.7294",
  "crm-message-bus": "static-1.43092",
  "customer-data-filters-ui-msw-helpers": "static-1.22398",
  "customer-data-objects-ui-components": "static-1.13076",
  "customer-data-reference-ui-components": "static-1.13213",
  "customer-data-ui-utilities": "static-1.9871",
  "framework-builder-read-service-client": "static-1.4041",
  "framework-data-schema-quick-fetch": "static-1.6837",
  "framework-data-schema-resolvers": "static-1.6932",
  "inbound-db-meta-service-client": "static-1.3622",
  "inbound-db-properties-service-client": "static-1.3882",
  "multi-account-reference-resolvers": "static-1.1026",
  "onboarding-tours": "static-1.16690",
  "reporting-datasets-permissions-lib": "static-1.13812",
  "ui-addon-teams": "static-1.21618",
  "quartz-auth": "static-1.762",
  "ui-business-units-lib": "static-1.9103",
  "usage-tracker-session-replay": "static-1.5081",
  "ai-components-ui-library": "static-1.9086",
  "ContentUtils": "static-1.68502",
  "customer-data-properties": "static-1.51728",
  "forms-ai-lib": "static-1.4386",
  "forms-utils-lib": "static-1.12668",
  "foundations-components-test-utils": "static-1.5503",
  "react-dnd-compat": "static-1.4659",
  "react-tinymce": "static-1.55374",
  "tinymce-config": "static-2.54500",
  "ui-gdpr-components": "static-1.10395",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3448",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3172",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.117",
  "ui-fonts": "static-1.781",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4371",
  "csstype": "static-1.50",
  "quartz-head": "static-1.752",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1587",
  "external-options-client-types": "static-1.4194",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.762",
  "frontend-preferences-client": "static-1.7971",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3744",
  "reporting-client-types": "static-1.2519",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25513",
  "hubspot-apollo-client": "static-1.4923",
  "foundations-components-legacy": "static-1.1045",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.517",
  "hs-story-utils": "static-1.9469",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.271",
  "timezone-utils": "static-2.5288",
  "seat-types-lib": "static-1.124",
  "bend-plugin-foundations-components": "static-1.4289",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2059",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-test": "static-1.762",
  "quartz-tracking": "static-1.466",
  "bend-plugin-chirp-manifest": "static-1.107",
  "chirp-fetch": "static-1.1933",
  "purchase-motions-components": "static-1.5997",
  "salesImages": "static-1.526",
  "ts-schema": "static-1.4115",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-foundations-theming": "static-1.2946",
  "stylex": "static-1.34",
  "hs-resources": "static-1.207",
  "pulse": "static-1.628",
  "restore-request-side-panel-lib": "static-1.1031",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3834",
  "crm-pipelines-api-client-types": "static-1.4176",
  "fdsr-migration-layer": "static-1.51",
  "multi-currency-client-types": "static-1.3728",
  "getting-started-shared-tasks": "static-1.18560",
  "growth-data-modal": "static-1.5498",
  "growth-onboarding-confetti": "static-1.3112",
  "growth-onboarding-next-action-utils": "static-1.2055",
  "navigation-components": "static-1.18156",
  "onboarding-tours-client": "static-1.4904",
  "onboarding-tours-utils": "static-1.756",
  "ui-shepherd-react": "static-3.10247",
  "ui-shepherd-tracker": "static-1.7628",
  "ui-universal-auth": "static-1.9032",
  "user-context": "static-1.5152",
  "hubspotter-http-shared-msw-handlers": "static-1.10071",
  "magpie-lib": "static-1.5581",
  "navigation-messaging": "static-1.7483",
  "amplitude-session-replay-browser": "static-1.63",
  "chatspot-core": "static-1.21486",
  "copilot-toolkit": "static-1.11256",
  "cms-field-types": "static-1.4857",
  "content-icons-ui": "static-1.2236",
  "integrations-lib": "static-1.16313",
  "calling-global-api": "static-1.64671",
  "calling-internal-common": "static-1.31349",
  "calling-lifecycle-internal": "static-1.66053",
  "calling-lifecycle-messages": "static-1.58347",
  "commerce-products-lib": "static-1.9734",
  "crm-links": "static-1.6349",
  "customer-data-properties-shared-msw-handlers": "static-1.9400",
  "file-manager-components": "static-1.23743",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4259",
  "meetings-icalendar-utils-lib": "static-1.677",
  "object-builder-ui-client": "static-1.48903",
  "pipeline-validation-client-types": "static-1.4002",
  "property-value-citations": "static-1.2342",
  "smart-property-lib": "static-1.7335",
  "tiered-pricing": "static-1.1318",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9105",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19909",
  "tinymce-themes": "static-1.56470",
  "data-token-picker": "static-1.16484",
  "hub-http-contrib": "static-1.3087",
  "interframe": "static-3.4804",
  "tinymce-data": "static-1.40585",
  "tinymce-plugins": "static-1.57614",
  "ui-addon-sales-email": "static-1.5256",
  "onboarding-scopes": "static-1.6507",
  "ui-addon-opt": "static-4.8408",
  "apollo-link-hub-http": "static-2.4697",
  "hubspot-apollo-cache": "static-1.382",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.216",
  "purchase-motions-api": "static-1.6000",
  "bend-plugin-pulse": "static-1.131",
  "event-emitter": "static-1.993",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2028",
  "growth-onboarding-next-action-components": "static-1.2083",
  "user-context-client": "static-1.4655",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5041",
  "nest": "static-1.277",
  "reactive-lib": "static-1.769",
  "simple-logging-lib": "static-1.3096",
  "unified-auth-core-lib": "static-1.828",
  "getting-started-shared-tasks-store": "static-1.17678",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.813",
  "integrations-error-boundary-lib": "static-1.13728",
  "integrations-tracking-lib": "static-1.5648",
  "native-integrations-shared-strings": "static-1.7827",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10409",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.546",
  "calling-error-reporting": "static-1.31356",
  "shared-worker-versioning": "static-1.11081",
  "calling-usage-tracker": "static-1.6586",
  "voice-sms-access-library": "static-1.1191",
  "customer-data-tracking": "static-1.6935",
  "commerce-permissions": "static-1.819",
  "products-iframe-lib": "static-1.8065",
  "products-ui-components-shared-msw-handlers": "static-1.10455",
  "location-customization-utils-lib": "static-1.9397",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4198",
  "video-components-external": "static-1.11442",
  "video-data-lib": "static-1.35100",
  "data-agent-kit": "static-1.265",
  "feedback-loader": "static-1.29379",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10156",
  "fsm": "static-1.3775",
  "policy-lib": "static-1.6822",
  "react-colorpicker": "static-2.10254",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10219",
  "FileManagerLib": "static-1.39383",
  "NamespacedHubStyle": "static-2.9095",
  "FileManagerCore": "static-1.39242",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7820",
  "layout-dnd-components": "static-1.12529",
  "layout-dnd-utils": "static-1.11504",
  "react-codemirror": "static-1.10673",
  "ui-addon-emoji-picker": "static-1.9931",
  "ui-brand-identity-lib": "static-1.15461",
  "InboxConnectUtils": "static-4.14942",
  "meetings-connect-utils-lib": "static-1.7650",
  "breeze-engine-core": "static-1.91",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3061",
  "google-sheets-integration-lib": "static-1.374",
  "microsoft-drive-integration-lib": "static-1.502",
  "slack-ui-library": "static-1.10437",
  "calling-orchestration-schema": "static-1.35968",
  "sales-views-client-types": "static-1.4302",
  "crm-record-cards-service-types": "static-1.3626",
  "content-media-composition-data-lib": "static-1.12498",
  "content-media-compositions": "static-2.16505",
  "media-bridge-lib": "static-1.19004",
  "trellis-story-utils": "static-1.4558",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.5983",
  "FileManagerImages": "static-1.36894",
  "video-components": "static-1.13444",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4583",
  "video-embed": "static-1.35934",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8749",
  "ui-coaching-tips": "static-1.28691",
  "ContentData": "static-1.68577",
  "layout-data-lib": "static-1.9829",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22230",
  "outpost": "static-1.4222",
  "growth-onboarding-feedback-components": "static-1.6625",
  "advanced-menus-core": "static-1.15198",
  "advanced-menus-lib": "static-1.12135",
  "ExportDialog": "static-6.10431",
  "ui-memberships-settings-lib": "static-1.34173",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15197",
  "simple-menus-lib": "static-1.16714"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34636",
  "atom": "/atom/static-1.5120",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2544",
  "client-types": "/client-types/static-1.473",
  "cssUtils": "/cssUtils/static-1.801",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39963",
  "customer-data-objects": "/customer-data-objects/static-1.7721",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8136",
  "documents-lib": "/documents-lib/static-1.34641",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85980",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4765",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2179",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5635",
  "hs-test-utils": "/hs-test-utils/static-1.8061",
  "hub-http": "/hub-http/static-1.6268",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11826",
  "HubStyleTokens": "/HubStyleTokens/static-2.11519",
  "I18n": "/I18n/static-7.1633",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3066",
  "jasmine-runner": "/jasmine-runner/static-1.6509",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7201",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5443",
  "quartz": "/quartz/static-1.7087",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5380",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8217",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8141",
  "reporting-data": "/reporting-data/static-1.67756",
  "reporting-reports": "/reporting-reports/static-1.67434",
  "reporting-snowflake": "/reporting-snowflake/static-1.56374",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9689",
  "reporting-visualizations": "/reporting-visualizations/static-1.59832",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8989",
  "sanitize": "/sanitize/static-1.4521",
  "sanitize-text": "/sanitize-text/static-1.8187",
  "self-service-api": "/self-service-api/static-1.10292",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1793",
  "signup-constants": "/signup-constants/static-1.18935",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8099",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4805",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4808",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11035",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11097",
  "ui-images": "/ui-images/static-2.1163",
  "UIComponents": "/UIComponents/static-3.8465",
  "usage-tracker": "/usage-tracker/static-1.7395",
  "usage-tracker-container": "/usage-tracker-container/static-1.7385",
  "usage-tracker-core": "/usage-tracker-core/static-1.7245",
  "viral-links-lib": "/viral-links-lib/static-1.7113",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9710",
  "foundations-components": "/foundations-components/static-1.8020",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.865",
  "quartz-core": "/quartz-core/static-1.6306",
  "quick-fetch": "/quick-fetch/static-1.3953",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4697",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11196",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18061",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3435",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3364",
  "quartz-webpack": "/quartz-webpack/static-1.3311",
  "foundations-assets": "/foundations-assets/static-1.4915",
  "foundations-theming": "/foundations-theming/static-1.4463",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10073",
  "hubspotter-http": "/hubspotter-http/static-1.4687",
  "sassPrefix": "/sassPrefix/static-1.157",
  "events-data-lib": "/events-data-lib/static-1.272",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7294",
  "crm-message-bus": "/crm-message-bus/static-1.43092",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22398",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13076",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13213",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9871",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4041",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6837",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6932",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3622",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3882",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1026",
  "onboarding-tours": "/onboarding-tours/static-1.16690",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13812",
  "ui-addon-teams": "/ui-addon-teams/static-1.21618",
  "quartz-auth": "/quartz-auth/static-1.762",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9103",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5081",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9086",
  "ContentUtils": "/ContentUtils/static-1.68502",
  "customer-data-properties": "/customer-data-properties/static-1.51728",
  "forms-ai-lib": "/forms-ai-lib/static-1.4386",
  "forms-utils-lib": "/forms-utils-lib/static-1.12668",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5503",
  "react-dnd-compat": "/react-dnd-compat/static-1.4659",
  "react-tinymce": "/react-tinymce/static-1.55374",
  "tinymce-config": "/tinymce-config/static-2.54500",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10395",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3448",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3172",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.117",
  "ui-fonts": "/ui-fonts/static-1.781",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4371",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.752",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1587",
  "external-options-client-types": "/external-options-client-types/static-1.4194",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.762",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7971",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3744",
  "reporting-client-types": "/reporting-client-types/static-1.2519",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25513",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4923",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1045",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.517",
  "hs-story-utils": "/hs-story-utils/static-1.9469",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.271",
  "timezone-utils": "/timezone-utils/static-2.5288",
  "seat-types-lib": "/seat-types-lib/static-1.124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4289",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2059",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-test": "/quartz-test/static-1.762",
  "quartz-tracking": "/quartz-tracking/static-1.466",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.107",
  "chirp-fetch": "/chirp-fetch/static-1.1933",
  "purchase-motions-components": "/purchase-motions-components/static-1.5997",
  "salesImages": "/salesImages/static-1.526",
  "ts-schema": "/ts-schema/static-1.4115",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2946",
  "stylex": "/stylex/static-1.34",
  "hs-resources": "/hs-resources/static-1.207",
  "pulse": "/pulse/static-1.628",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1031",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3834",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4176",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.51",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3728",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18560",
  "growth-data-modal": "/growth-data-modal/static-1.5498",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3112",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2055",
  "navigation-components": "/navigation-components/static-1.18156",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4904",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.756",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10247",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7628",
  "ui-universal-auth": "/ui-universal-auth/static-1.9032",
  "user-context": "/user-context/static-1.5152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10071",
  "magpie-lib": "/magpie-lib/static-1.5581",
  "navigation-messaging": "/navigation-messaging/static-1.7483",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.63",
  "chatspot-core": "/chatspot-core/static-1.21486",
  "copilot-toolkit": "/copilot-toolkit/static-1.11256",
  "cms-field-types": "/cms-field-types/static-1.4857",
  "content-icons-ui": "/content-icons-ui/static-1.2236",
  "integrations-lib": "/integrations-lib/static-1.16313",
  "calling-global-api": "/calling-global-api/static-1.64671",
  "calling-internal-common": "/calling-internal-common/static-1.31349",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66053",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58347",
  "commerce-products-lib": "/commerce-products-lib/static-1.9734",
  "crm-links": "/crm-links/static-1.6349",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9400",
  "file-manager-components": "/file-manager-components/static-1.23743",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4259",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.677",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48903",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4002",
  "property-value-citations": "/property-value-citations/static-1.2342",
  "smart-property-lib": "/smart-property-lib/static-1.7335",
  "tiered-pricing": "/tiered-pricing/static-1.1318",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9105",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19909",
  "tinymce-themes": "/tinymce-themes/static-1.56470",
  "data-token-picker": "/data-token-picker/static-1.16484",
  "hub-http-contrib": "/hub-http-contrib/static-1.3087",
  "interframe": "/interframe/static-3.4804",
  "tinymce-data": "/tinymce-data/static-1.40585",
  "tinymce-plugins": "/tinymce-plugins/static-1.57614",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5256",
  "onboarding-scopes": "/onboarding-scopes/static-1.6507",
  "ui-addon-opt": "/ui-addon-opt/static-4.8408",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4697",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.382",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.216",
  "purchase-motions-api": "/purchase-motions-api/static-1.6000",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.131",
  "event-emitter": "/event-emitter/static-1.993",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2028",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2083",
  "user-context-client": "/user-context-client/static-1.4655",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5041",
  "nest": "/nest/static-1.277",
  "reactive-lib": "/reactive-lib/static-1.769",
  "simple-logging-lib": "/simple-logging-lib/static-1.3096",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.828",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17678",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.813",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13728",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5648",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7827",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10409",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.546",
  "calling-error-reporting": "/calling-error-reporting/static-1.31356",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11081",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6586",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1191",
  "customer-data-tracking": "/customer-data-tracking/static-1.6935",
  "commerce-permissions": "/commerce-permissions/static-1.819",
  "products-iframe-lib": "/products-iframe-lib/static-1.8065",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10455",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9397",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4198",
  "video-components-external": "/video-components-external/static-1.11442",
  "video-data-lib": "/video-data-lib/static-1.35100",
  "data-agent-kit": "/data-agent-kit/static-1.265",
  "feedback-loader": "/feedback-loader/static-1.29379",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10156",
  "fsm": "/fsm/static-1.3775",
  "policy-lib": "/policy-lib/static-1.6822",
  "react-colorpicker": "/react-colorpicker/static-2.10254",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10219",
  "FileManagerLib": "/FileManagerLib/static-1.39383",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9095",
  "FileManagerCore": "/FileManagerCore/static-1.39242",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7820",
  "layout-dnd-components": "/layout-dnd-components/static-1.12529",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11504",
  "react-codemirror": "/react-codemirror/static-1.10673",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9931",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15461",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14942",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7650",
  "breeze-engine-core": "/breeze-engine-core/static-1.91",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3061",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.374",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.502",
  "slack-ui-library": "/slack-ui-library/static-1.10437",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35968",
  "sales-views-client-types": "/sales-views-client-types/static-1.4302",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3626",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12498",
  "content-media-compositions": "/content-media-compositions/static-2.16505",
  "media-bridge-lib": "/media-bridge-lib/static-1.19004",
  "trellis-story-utils": "/trellis-story-utils/static-1.4558",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.5983",
  "FileManagerImages": "/FileManagerImages/static-1.36894",
  "video-components": "/video-components/static-1.13444",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4583",
  "video-embed": "/video-embed/static-1.35934",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8749",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28691",
  "ContentData": "/ContentData/static-1.68577",
  "layout-data-lib": "/layout-data-lib/static-1.9829",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22230",
  "outpost": "/outpost/static-1.4222",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6625",
  "advanced-menus-core": "/advanced-menus-core/static-1.15198",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12135",
  "ExportDialog": "/ExportDialog/static-6.10431",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34173",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15197",
  "simple-menus-lib": "/simple-menus-lib/static-1.16714"
}
};
